module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-001"
    }
  }, [_vm._v("Basic Principles of Approach")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 - T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Promise of a Distinctive Blessing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Promise of a Universal Blessing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Day of Pentecost")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Samaritan Believers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ephesian Disciples")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Language of Baptism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Corinthians 12:13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 - T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULLNESS OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Difference Between “Baptism” and “Fullness”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuous Appropriation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marks of the Spirit’s Fullness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Command to Be Filled")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Average Christian")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Experiences")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Exhortation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 - T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supernatural Origin")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natural Growth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gradual Maturity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Application")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 - T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFTS OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of Spiritual Gifts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Many Different Gifts Are There?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Relationship Between Spiritual Gifts and Natural Talents")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are All Spiritual Gifts Miraculous Gifts?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are All the Spiritual Gifts of the Bible Given Today?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Word "), _c('i', [_vm._v("Charismatic")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Extent of Spiritual Gifts: To Whom Are They Given?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Source of Spiritual Gifts: Where Do They Come From?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Purpose of Spiritual Gifts: What Are They Given For?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Classics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0